module.exports = "/_next/static/images/GettingStarted1-7f107c65f061eccaaf5fb090d2b062d1.png";